/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  DashboardChartType,
  SalesLeadsBudgetsDto,
  SalesLeadsBudgetsPoint,
  SalesLeadsBudgetsValue,
} from '../dto';

export const SalesLeadsBudgetsMapper = entity<SalesLeadsBudgetsDto>({
  values: arrayOf(subentity<SalesLeadsBudgetsValue>({
    points: arrayOf(subentity<SalesLeadsBudgetsPoint>({
      type: enumeration(DashboardChartType),
    })),
  })),
});
